import { render, staticRenderFns } from "./ImsPriceChangeList.vue?vue&type=template&id=17e71a7b&"
import script from "./ImsPriceChangeList.vue?vue&type=script&lang=js&"
export * from "./ImsPriceChangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports